export default __webpack_public_path__ + "0470ed7a2d58cd51b5cbf6e4d4a76b87.png";